import { withStyles, Grid, List, Divider } from '@material-ui/core';
import React, { useMemo } from 'react'
import { withTranslation } from 'react-i18next';
import { compose } from 'recompose';
import withErrorCatcher from '../../../Common/withErrorCatcher';
import { push } from 'react-router-redux';
import LeftDrawerFooter from './LeftDrawerFooter'
import DrawerListItem from "./drawerListItem";
import LeftDrawerDefaultItems from "./LeftDrawerDefaultItems";
import { connect } from 'react-redux';
import LeftDrawerCustomItems from './LeftDrawerCustomItems';
import { FluencyIcons } from '@tuqqi/common'
import SVG from 'react-inlinesvg';
import { themeConstants } from '../../../../../theme';

const adminIconPath = FluencyIcons.fluencyIconAdministrativeTools.data

// Apply some reset
const styles = theme => ({
    list: {
        paddingLeft: 16
     },
    container: {
        marginTop: 8,
        zIndex: 2,
        bottom: 0,
        position: 'fixed',
        overscrollBehavior: 'contain',
        overflowY: 'auto',
        maxHeight: `calc(100vh - ${theme.constants.defaultToolbarHeight + 16}px)`,
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        top: theme.constants.defaultToolbarHeight
    },
    show: {
        width: themeConstants.leftDrawerWidth,
        [theme.breakpoints.down('1071')]: {
            width: themeConstants.leftDrawerSmallWidth
        }
    },
    hidden: {
        width: 0
    },
    divider: {
        backgroundColor: '#e0e0e0',
        marginTop: 8,
        marginBottom: 8,
    },
});

const _LeftDrawer = (props) => {
    const {classes, t, dispatch, userData, pathname, canOpenMenu} = props

    const show = useMemo(() => pathname === '/' || pathname === '/feed' ,[pathname])

    const onGoToAdmin = () => {
        dispatch(push('/admin'))
    }
    const DefaultItems = <LeftDrawerDefaultItems />
    const CustomItems = <LeftDrawerCustomItems />

    const AdminItem = userData.profileData.role === "Admin" &&
            <DrawerListItem
                id="admin_item"
                selectedCondition={false}
                onClick={onGoToAdmin}
                icon={<SVG src={adminIconPath} />}
                text={t('Admin')} />

    if(!show) return null

    return <Grid className={`${classes.container} ${!!canOpenMenu ? classes.show : classes.hidden}`}>
        <List className={classes.list}>
            {DefaultItems}
            {CustomItems}
            <Divider className={classes.divider} />
            {AdminItem}
            <div data-intrcm-id="leftDrawer_gsp9id77" className={classes.listItem}>
                <LeftDrawerFooter />
            </div>
        </List>
    </Grid>
}

const mapStateToProps = (state) => ({
    userData: state.userData,
    pathname: state?.wrapper?.pathname ?? '',
    canOpenMenu: state?.wrapper?.canOpenMenu ?? false
})

const mapDispatchToProps = dispatch => ({dispatch})

export const LeftDrawer = compose(
    withStyles(styles, { withTheme: true }),
    withErrorCatcher(),
    withTranslation('drawerListItemTerms'),
    connect(mapStateToProps, mapDispatchToProps)
)(_LeftDrawer);